import {
  EDITING_DOCUMENTS_LIST_DELETE_FAILURE,
  EDITING_DOCUMENTS_LIST_DELETE_REQUEST,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsErrorWhileDeletingState = string | null;

const initialState: EditingDocumentsErrorWhileDeletingState = null;

export default function reducer(
  state: EditingDocumentsErrorWhileDeletingState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_LIST_DELETE_REQUEST:
      return initialState;
    case EDITING_DOCUMENTS_LIST_DELETE_FAILURE:
      return action.payload.message;
    default:
      return state;
  }
}
